import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=3084ff8f"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3084ff8f')) {
      api.createRecord('3084ff8f', component.options)
    } else {
      api.reload('3084ff8f', component.options)
    }
    module.hot.accept("./Navbar.vue?vue&type=template&id=3084ff8f", function () {
      api.rerender('3084ff8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navbar/Navbar.vue"
export default component.exports